import React from 'react'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, BACK_URL, REGISTER_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import { fetchDetails } from './Api';

export default function Quote({ pageid }) {


    const [quote, setquote] = useState([])

    useEffect(() => {
        const fetchData = async ({ pageid }) => {
            const url = `${API_URL}/quote/${pageid}`;
            const data = await fetchDetails(url);
            if (data) {
                setquote(data);
            }
        };
        fetchData({ pageid });
    }, [pageid]);


    return (
        <>
            <section className="tg-haslayout tg-appbg tg-bgparallax">
                <div className="container">
                    <div className="row">
                        <div className="tg-getapp">

                            {quote?.map(quot => (
                                <>

                                    <div key={quot.id} className="col-xs-12 col-sm-12 col-md-9 col-lg-9">

                                        <div className="tg-sectionhead tg-textalignleft">


                                            <div className="tg-description tg-sectionheading" style={{ paddingTop: "50px", textAlign: "justify" }}>
                                                <div dangerouslySetInnerHTML={{ __html: quot.subtitle }}></div>

                                            </div>

                                            <div>
                                                <h4 class="head">
                                                    {quot.author}</h4>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                        <div className="tg-appcontent">
                                            <div className="tg-sectionhead">


                                                <img className='rounded' src={`${BACK_URL}/${quot.image}`} alt="" />


                                            </div>


                                        </div>
                                    </div>

                                </>

                            ))}



                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
